var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDifferentiateAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2891.34 1247.24",
    height: 1247.24,
    width: 2891.34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        stroke: #e3000f;\n      }\n\n      .cls-8 {\n        fill: #030202;\n      }\n\n      .cls-8, .cls-9 {\n        opacity: .2;\n      }\n\n      .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26 {\n        stroke-width: 0px;\n      }\n\n      .cls-8, .cls-9, .cls-26 {\n        isolation: isolate;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        stroke: #030202;\n      }\n\n      .cls-5 {\n        stroke: #000;\n      }\n\n      .cls-6 {\n        stroke: #8c4fc2;\n      }\n\n      .cls-7 {\n        stroke: #cf5934;\n      }\n\n      .cls-10 {\n        opacity: .5;\n      }\n\n      .cls-10, .cls-12, .cls-23 {\n        fill: #8c4fc2;\n      }\n\n      .cls-27, .cls-12 {\n        opacity: .3;\n      }\n\n      .cls-13 {\n        fill: #4f051f;\n      }\n\n      .cls-14 {\n        fill: #5b2c2f;\n      }\n\n      .cls-15 {\n        fill: #9c2b42;\n      }\n\n      .cls-16 {\n        fill: #6f0b2e;\n      }\n\n      .cls-17 {\n        fill: #58595b;\n      }\n\n      .cls-18 {\n        fill: #231f20;\n      }\n\n      .cls-19 {\n        fill: #e3000f;\n      }\n\n      .cls-20 {\n        fill: #e08253;\n      }\n\n      .cls-21 {\n        fill: #b1b1b1;\n      }\n\n      .cls-22 {\n        fill: #939393;\n      }\n\n      .cls-24 {\n        fill: #303030;\n      }\n\n      .cls-25 {\n        fill: #fff;\n      }\n\n      .cls-26 {\n        opacity: .15;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m2084.54,399.97h345.06c24.75,0,44.99,20.09,44.99,44.99v345.06c0,24.75-20.09,44.99-44.99,44.99h-345.06c-24.75,0-44.99-20.09-44.99-44.99v-345.06c0-24.9,20.09-44.99,44.99-44.99Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icone"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3,
    y: -6,
    width: 2891,
    height: 1253
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m362.98,851.99l-50.1-5.79,7.3-43.3c.2-1-.4-1.9-1.3-2.2s-1.9.1-2.4.9l-20,35.6-33.3-36.1c-.7-.7-1.8-.9-2.6-.3-.8.6-1.1,1.6-.7,2.5l20.9,43.79-35.5,8c-.9.2-1.6,1-1.6,2s.7,1.8,1.6,1.9l36.1,6.5-14.5,54.8c-.3,1,.2,2,1.2,2.4.2.1.5.2.8.2.7,0,1.4-.4,1.7-1l27.3-47.1,24.5,26.6c.6.7,1.7.9,2.5.4.8-.5,1.2-1.5.8-2.4l-12.3-34.4,49.6-9.1c1-.2,1.7-1,1.6-2-.1-1-.6-1.8-1.6-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m636.48,319.27c98.39-24.11,280.11,77.99,412.39,64.95,133.1-13.11,215.93-141.29,306.89-165.59,90.97-24.3,189.16,54.53,213.88,150.4,24.79,96.67-24.7,210.46-82.65,292.86-57.21,81.51-122.89,131.63-190.41,179.44-67.46,48.63-137.64,94.2-249.4,135.12-111.83,40.1-265.23,75.55-361.46,19.61-97.04-55.88-136.83-202.32-148.9-351.98-12.8-148.76,1.36-299.85,99.67-324.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m2398.11,363.75c.73,14.75,13.28,26.11,28.03,25.38,14.75-.74,26.11-13.29,25.38-28.04-.74-14.75-13.29-26.11-28.04-25.38-14.75.74-26.11,13.29-25.37,28.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m2464.38,298.71c.54,10.93,9.85,19.36,20.78,18.81,10.93-.54,19.36-9.85,18.81-20.78s-9.85-19.36-20.78-18.81c-10.93.55-19.36,9.85-18.81,20.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m753.52,152.3c-30.26,15.03-42.59,51.64-27.67,81.86,8.15,16.48,23.38,28.43,41.31,32.48,11.61,2.57,21.33,10.34,26.39,21.03l5.8,4.8,32.71-15.22,1.98-8.43c-4.96-10.64-4.73-23.05.75-33.47,15.64-29.9,4.18-66.79-25.75-82.51-17.33-9.01-37.99-9.24-55.52-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m793.59,287.73l6.57,14.12c5.21,11.18,18.43,16,29.61,10.8,11.19-5.21,16.01-18.43,10.8-29.62l-6.57-14.11-40.41,18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m793.55,287.66l40.49-18.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m798.76,298.84l40.42-18.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m806.98,281.41l-7.51-16.12c-5.03-10.8-14.11-19.24-25.3-23.31-8.48-3.1-15.26-9.41-19.08-17.59-2.69-5.78-.14-12.6,5.57-15.26,5.78-2.69,12.6-.14,15.26,5.57l2.8,6.01c1.72,3.7,6.13,5.31,9.83,3.58,3.7-1.72,5.31-6.13,3.58-9.83l-2.8-6.02c-2.69-5.78-.14-12.6,5.57-15.26l.15-.07c5.78-2.69,12.6-.14,15.27,5.57,3.81,8.18,4.23,17.55,1.14,26.02-4.05,11.27-3.56,23.61,1.51,34.49l7.54,16.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m506.47,354.44c.73,14.75,13.28,26.11,28.03,25.38,14.75-.74,26.11-13.29,25.38-28.04-.74-14.75-13.29-26.11-28.04-25.38-14.75.74-26.11,13.29-25.37,28.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m433.47,231.44c.73,14.75,13.28,26.11,28.03,25.38,14.75-.74,26.11-13.29,25.38-28.04-.74-14.75-13.29-26.11-28.04-25.38-14.75.74-26.11,13.29-25.37,28.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m2084.54,404h345.06c24.75,0,44.99,20.09,44.99,44.99v345.06c0,24.75-20.09,44.99-44.99,44.99h-345.06c-24.75,0-44.99-20.09-44.99-44.99v-345.06c0-24.9,20.09-44.99,44.99-44.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1998.96,1048.96c29.7,21.5,96.7-3.8,138.1-28.6,46-27.6,48.1-57.3,29.7-57.3-25.6,0-89,78.8-52.2,96.1,30.4,14.4,85.9-11.2,100.2,5.1,14.3,16.3,20.5,52.2,60.3,70.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1898.31,799.23l1.22-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1902.97,705.55l1.22-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1842.22,737.25l24.4,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1935.88,741.91l24.4,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1940.89,783.98l-16.33-18.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1877.94,714.44l-16.33-18.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1857.45,779.83l18.04-16.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1927.01,716.87l18.04-16.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1707.31,296.23l1.22-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1711.97,202.55l1.22-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1651.22,234.25l24.4,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1744.88,238.91l24.4,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1749.89,280.98l-16.33-18.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1686.94,211.44l-16.33-18.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1666.45,276.83l18.04-16.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1736.01,213.87l18.04-16.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m1674.11,404h-230.79c-12.36,0-22.42,10-22.42,22.42v148.22c0,12.37,10.01,22.42,22.42,22.42h230.83c12.37,0,22.42-10.01,22.42-22.42v-148.22c-.05-12.41-10.1-22.42-22.47-22.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1448.03,439.22c4.47,0,8.09-3.63,8.09-8.09s-3.63-8.09-8.09-8.09-8.09,3.63-8.09,8.09,3.62,8.09,8.09,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1472.22,439.22c4.47,0,8.09-3.63,8.09-8.09s-3.63-8.09-8.09-8.09-8.09,3.63-8.09,8.09,3.62,8.09,8.09,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1496.4,439.22c4.47,0,8.1-3.63,8.1-8.09s-3.63-8.09-8.1-8.09-8.09,3.63-8.09,8.09,3.63,8.09,8.09,8.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m1969.08,404h-230.79c-12.36,0-22.42,10-22.42,22.42v148.22c0,12.37,10.01,22.42,22.42,22.42h230.83c12.37,0,22.42-10.01,22.42-22.42v-148.22c-.05-12.41-10.1-22.42-22.47-22.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1743.01,439.22c4.47,0,8.09-3.63,8.09-8.09s-3.63-8.09-8.09-8.09-8.09,3.63-8.09,8.09,3.62,8.09,8.09,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1767.2,439.22c4.47,0,8.09-3.63,8.09-8.09s-3.63-8.09-8.09-8.09-8.09,3.63-8.09,8.09,3.62,8.09,8.09,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1791.38,439.22c4.47,0,8.1-3.63,8.1-8.09s-3.63-8.09-8.1-8.09-8.09,3.63-8.09,8.09,3.63,8.09,8.09,8.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m1818.93,505.75h-29.85v63.81h29.85v-63.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1867.09,452.13h-29.85v117.42h29.85v-117.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1915.26,474.26h-29.85v95.29h29.85v-95.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1584.76,895.72c14.4,0,27.99-11.73,30.3-26.14l29.11-183.39c.61-3.26.49-6.62-.34-9.84-.83-3.22-2.37-6.21-4.48-8.77-2.13-2.44-4.77-4.38-7.74-5.69-2.97-1.3-6.18-1.93-9.42-1.86h-278.04c-14.39,0-27.98,11.72-30.29,26.13l-29.11,183.4c-.69,3.22-.64,6.56.16,9.75.79,3.2,2.31,6.18,4.43,8.7,2.12,2.52,4.79,4.53,7.8,5.86,3.01,1.34,6.29,1.96,9.59,1.83h278.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m1494.57,895.57l12.66-79.04-87.94-.05-12.67,79.09h87.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1540.75,941.03l-33.38-124.65-87.93-.03,33.38,124.69h87.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m1473.83,769.1c9.25,0,18.34-7.14,22.61-17.76,2.58-6.14,3.05-12.96,1.32-19.39-.68-2.76-2-5.34-3.84-7.51-1.83-2.17-4.16-3.89-6.77-5.02-1.98-.79-4.08-1.2-6.21-1.19-9.25,0-18.33,7.14-22.61,17.76-5.38,13.36-1.21,27.68,9.3,31.92,1.98.79,4.08,1.2,6.21,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1527.98,894.82l-20.65-77h-87.9l20.65,77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1432.2,941.03l.04-2.91c0-4.54-1.81-8.89-5.01-12.09-3.21-3.2-7.55-5.01-12.09-5.01h-281.32c-4.54,0-8.88,1.81-12.09,5.01-3.2,3.2-5.01,7.55-5.01,12.09v2.91h315.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1234.32,941.03l.04-2.91c0-4.54-1.81-8.89-5.02-12.09-3.2-3.2-7.55-5.01-12.09-5.01h-83.45c-4.54,0-8.88,1.81-12.09,5.01-3.2,3.2-5.01,7.55-5.01,12.09v2.91h117.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1680.6,773.52l-6.31,5.66c-.11,0-.11.11-.11.22l-5.32,16.63c0,.11,0,.22.21.22l16.64-.11s13.91-5.98,15-6.53v-.1l-11.74-13.27s-.11-.11-.22-.11l-8.15-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m1710.93,803.42l9.57-14.24,7.61-.98,7.6,1.96,7.61,15.43q0,.11-.1.11l-16.09,2.29-16.09-4.46q-.22,0-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1735.61,866.36l-49.58.87-22.61-26.3c-.11-.11,0-.22.11-.22h93.06c.11,0,.11.11.11.22l-21.09,25.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m1724.74,905.39l-24.03-115.88c0-.11-.11-.11-.11-.11l-31.63,6.52c-.11,0-.11.11-.11.11l23.91,115.99,31.97-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m1678.75,765.15l-4.67,14.03q0,.11.1.11l14.46-3.05c.11,0,.11-.11.11-.21l-9.78-10.98s-.11,0-.22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1743.22,805.7l-32.29-2.17q-.11,0-.11.11l-7.72,118.17,32.51,2.06,7.71-118.17h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1729.08,776.68l6.53,13.48-15.11-.98,8.37-12.61s.1,0,.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m1709.95,856.91c-16.85.11-33.27-5.55-46.53-16.09-.11-.11-.22,0-.22.11l6.42,58.48,10.43,35.12,59.36-.55,10.98-35.44,6.31-57.61c0-.11-.11-.11-.22-.11-13.26,10.54-29.68,16.2-46.53,16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1750.39,898.54c-23.48-19.78-57.62-19.24-80.66.87v.11l4.45,40.99h71.75l4.46-41.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1945.55,943.89H486.91v36.11h1458.64v-36.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m892.68,632.85v-11.25c0-.14.15-.28.29-.28,41.71,14.09,63.06-4.13,60.78-40,0,0-.71-11.39-.71-12.39v-.14c1.57-.85,10.11-5.55,10.11-11.96s-8.54-9.68-10.11-10.39l-.14-.14c1.99-62.35-32.03-94.1-92.25-91.39-15.51.71-65.91,8.68-65.91,77.58l-.42,100.36q0,.14.14.14l98.22-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m892.68,621.75c0-.29-.14-.43-.42-.57-11.25-3.99-21.07-6.84-28.62-10.82-.42-.15-.71.28-.42.57l28.9,32.17c.28.28.85,0,.71-.43,0-2.56-.15-17.65-.15-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m1150.92,794.71c13.52-14.81,15.8-18.79,26.9-31.04,8.4,4.13,28.61,2.99,40.86-1.42,8.25,13.24,23.06,8.11,35.87-3.99,5.27-4.98,10.39-12.95,7.69-22.06,6.97-4.27,7.97-17.08,2.99-22.78,6.69-6.55,4.69-20.07-3.99-22.92,3.7-6.12,4.56-16.8-4.84-22.77-9.39-6.84-42.99-6.69-56.23-5.84,5.27-10.25,22.07-30.89,13.67-39.58-9.68-9.96-62.21,34.17-74.31,42.57-8.97,6.97-27.9,21.92-54.52,43.13-.29.29-.43.71-.29,1.14,4.41,7.97,63.49,81.85,66.2,85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m953.9,944.46c0,.43-7.69-27.04-12.39-37.86-.14.14-203.56-.86-203.56-.43-6.84,11.96-12.39,24.77-16.66,37.87-1.28,1.28,231.47.57,232.61.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m892.68,621.18c-8.68-2.71-29.04-10.82-29.04-10.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m855.25,570.21l-9.97-9.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m935.82,583.88c-7.12,1-12.67-4.56-13.24-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m930.98,540.6c-5.84.15-5.84,8.69,0,8.83,5.83-.14,5.83-8.68,0-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m677.16,939.2c35.87,2.27,76.87-23.49,88.97-32.46.14-.14.29-.14.43-.14h174.81c.14,0,.28,0,.43-.15,1.85-1.42,15.94-13.8,11.67-45.41-.14-.57.57-.99,1.14-.71,16.51,11.67,33.03,18.22,50.11,19.65,42.42,3.7,88.54-24.35,147.19-86.27.29-.28.29-.85,0-1.28-5.69-7.26-58.79-75.02-65.91-84.13-.42-.57-1.28-.71-1.85-.29-28.47,22.49-57.65,45.98-62.49,49.83-.29.28-.71.14-1-.15-4.7-5.97-36.44-45.12-67.76-79-19.5-21.07-36.16-31.32-58.51-35.02-.99-.14-1.56-1-1.56-1.85l-.15-9.54c0-.43-.28-.71-.71-.71h-96.94c-.43,0-.71.28-.71.71v8.68c0,.43-.29.71-.71.71-7.69.29-60.36,3.85-96.52,35.31-34.17,31.32-104.49,130.11-95.66,195.02,6.26,55.67,44.7,67.2,75.73,67.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m998.17,875.14c-.29-.15-16.8-9.97-30.89-57.66-7.69-25.91-24.06-27.47-23.92-23.2,1.43,27.05,9.54,63.63,9.97,65.2v.14c4.55,3.13,22.92,17.79,50.82,20.5.14,0,.28-.14.14-.29l-6.12-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m880.44,944.18l-3.13-37.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m921.44,944.18l-7.54-37.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m838.87,944.18l.57-37.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m794.89,944.18l.42-37.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m763,943.89l-.85-30.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m717.02,822.61s.14,0,0,0c4.27-10.96,7.4-19.79,12.24-32.17,3.28-8.12,2.14-4.99,4.27-11.39,0-.15-.14-.29-.14-.15-17.65,7.41-38.86,32.03-45.41,55.67,0,.14.14.28.14.14,2.85-1.28,27.62-11.53,28.9-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m735.95,814.64l-47.83,20.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m733.67,778.76l-16.08,41.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m953.19,859.48c-4.13-19.22-7.55-44.7-9.83-65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1021.09,759.12l12.53-10.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1260.1,690.79c-11.39,9.96-46.83,21.64-51.25,11.39-2.7-6.55,1.57-15.38,13.24-21.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1264.37,713.56c-11.39,8.55-40.43,17.37-48.4,12.82-9.96-5.7-4.27-17.66,0-20.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1261.53,736.34c-11.39,5.69-35.59,17.08-44.13,9.97-8.55-7.12,3.55-18.65,3.55-18.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1218.82,762.11c-.71-4.27.85-8.69,4.27-11.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1198.89,662.46l-7.12,8.54s-4.27,42.71-28.47,61.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m837.02,588.86v-.14c-.99-1.57-18.5-20.22-17.65-37.73.43-6.26,2.99-11.67,7.69-15.94,15.23-14.66,45.41,8.54,46.98,11.1.14.15,2.42,2.42,2.42,2.42.28.29.71.15.85,0,.43-.28,6.41-4.98,6.69-5.26,16.09-12.53,19.79-8.69,20.36-37.73,0-.14.14-.14.14-.14,15.37,5.27,32.88,8.83,43.7,5.55,0,0,.43-.14.71-.14.15,0,.29-.14.29-.14v-.43c-5.41-45.55-44.7-66.76-89.68-63.63-80.15,7.26-64.21,83.85-65.34,156.73q0,.14.14.14c2.42,0,28.18,1.85,42.7-14.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m785.21,890.51l24.34-18.51c2.28-.14,20.78-2.27,52.53-27.47,5.12-4.13,14.8-6.12,24.06-7.97,11.67-2.42,22.77-4.7,22.77-11.11,0-3.7-8.4-5.69-25.05-5.69-6.26,0-12.53.29-16.37.43-.43,0-.43-.43-.14-.57,9.68-3.7,34.87-13.95,41.85-22.21,8.97-10.82,4.55-18.08,3.13-19.93-.14-.14-.14-.28,0-.43,1-1.28,4.13-5.83,1.28-12.81-2.56-6.26-9.54-6.12-14.09-4.98-.14,0-.29-.14-.43-.28-.14-.86-.57-2.14-1.57-3.56-1.42-2.71-8.68-5.13-14.66-4.13-14.09,1.42-47.54,13.09-54.66,15.51-.29.15-.57-.14-.43-.42,1.57-3.7,6.41-15.09-.71-16.66-9.82-.57-43.13,30.61-54.67,43.42-2.7,3.13-15.08,10.25-36.72,21.35-1.14-.14,46.41,77.3,46.12,77.44.14.15.29.15.43.15l2.99-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m899.09,759.69c-18.65,5.55-73.88,26.05-73.88,26.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m912.04,777.2l-75.16,26.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m828.2,766.8l-15.23,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m782.22,892.08l-15.66,14.52"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "commun_illustration_for_session",
    "data-name": "commun illustration for session"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m2356.99,906.23h215.62c10.18.01,19.94,4.05,27.14,11.25,7.2,7.2,11.24,16.96,11.25,27.14v23.6c-.01,10.18-4.05,19.95-11.25,27.14-7.2,7.2-16.96,11.25-27.14,11.25h-215.62c-10.18,0-19.94-4.05-27.14-11.25-7.2-7.19-11.24-16.96-11.25-27.14v-23.6c.01-10.18,4.05-19.94,11.25-27.14,7.2-7.2,16.96-11.24,27.14-11.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2372.33,975.95c10.83,0,19.61-8.78,19.61-19.62s-8.78-19.62-19.61-19.62-19.62,8.79-19.62,19.62,8.78,19.62,19.62,19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2386.21,970.22l5.97,5.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2416.69,973.35h154.53"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m249.08,709.77c39.5-34.8,112.7-81.8,174-41.9,0,0-60.3-78.8-29.6-115.6,40.1-48.2,158.1,82.8,140.4,105.3-18.2,23-58.9-79.9-37.6-137.1,16.8-45,97,22.5,109.9,62.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m2563.27,417.37c-25.88,1.15-45.89,23-44.81,48.82.6,14.08,7.57,27.2,18.89,35.59,7.35,5.4,11.75,13.87,11.99,22.94l2.58,5.17,27.66-.53,4.01-5.3c-.17-9,3.84-17.63,10.91-23.24,20.25-16.12,23.66-45.55,7.55-65.86-9.36-11.7-23.78-18.27-38.78-17.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m2549.35,524.79l.23,11.94c.18,9.46,7.96,16.94,17.42,16.76,9.46-.18,16.95-7.96,16.76-17.42l-.23-11.93-34.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2549.34,524.73l34.25-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2549.52,534.18l34.19-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2560.7,524.51l-.26-13.64c-.17-9.13-3.93-17.87-10.51-24.2-4.99-4.8-7.78-11.34-7.92-18.25-.09-4.89,3.81-8.88,8.64-8.97,4.89-.09,8.88,3.81,8.97,8.64l.1,5.09c.06,3.13,2.65,5.62,5.79,5.56,3.13-.06,5.62-2.65,5.56-5.78l-.09-5.09c-.09-4.89,3.81-8.88,8.64-8.97h.13c4.89-.1,8.88,3.81,8.98,8.64.13,6.92-2.48,13.62-7.28,18.6-6.33,6.65-9.82,15.46-9.64,24.66l.32,13.57"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1584.42,506.35c.5,0,.9-.39.9-.88s-.4-.87-.9-.87m0,1.75c-.5,0-.9-.39-.9-.88s.4-.87.9-.87m-28.3-42.88c36.38,0,44.02,28.88,57.05,61.69.9,2.63-.9,5.25-3.59,5.25h-9.43v14.88c0,8.31-6.74,14.88-15.27,14.88h-28.75v-96.69Zm-15.44,32.81h15.44m-21.89,32.81h8.98v15.29m-11.23.02h24.13m-30.88,6.56c3.72,0,6.74-2.94,6.74-6.56s-3.02-6.56-6.74-6.56-6.74,2.94-6.74,6.56,3.02,6.56,6.74,6.56Zm.57-39.38h30.31m-37.05,6.56c3.72,0,6.74-2.94,6.74-6.56s-3.02-6.56-6.74-6.56-6.74,2.94-6.74,6.56,3.02,6.56,6.74,6.56Zm12.91-39.38h24.14m-30.88,6.56c3.72,0,6.74-2.94,6.74-6.56s-3.02-6.56-6.74-6.56-6.74,2.94-6.74,6.56,3.02,6.56,6.74,6.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2209.9 748.53 2209.9 642 2166.62 642"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2243.19 711.91 2243.19 585.41 2196.58 585.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2276.48,
    y1: 651.99,
    x2: 2276.48,
    y2: 542.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2309.77 748.53 2309.77 612.04 2353.05 612.04"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2146.64,
    cy: 642,
    r: 19.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2176.61,
    cy: 585.41,
    r: 19.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2276.48,
    cy: 522.15,
    r: 19.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2373.03,
    cy: 612.04,
    r: 19.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2276.48,
    y1: 678.62,
    x2: 2276.48,
    y2: 731.89
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentiateAi);
export default __webpack_public_path__ + "static/media/differentiate-ai.19b55181e6ac00ef1144bcb08d02cc20.svg";
export { ForwardRef as ReactComponent };